"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RATE_LIMITER_INTERVAL_IN_MS = exports.RATE_LIMIT_THRESHOLDS_PER_MINUTE = void 0;
exports.RATE_LIMIT_THRESHOLDS_PER_MINUTE = {
    COINGECKO: 500,
    COINCAP: 200,
    DEFAULT: 300, // default for services
};
exports.DEFAULT_RATE_LIMITER_INTERVAL_IN_MS = 60000;
